// extracted by mini-css-extract-plugin
export default {"base":"Base_base__MN24u","body":"Base_body__69MWE"};